import { motion } from "framer-motion";
import { Star } from "./Star";
import { useI18n } from "@/context/LanguageContext";

export const Schedule = () => {
  const { t } = useI18n();
  const s = t.schedule;
  return (
    <section id="horaris" data-testid="schedule-section" className="bg-[#141518] text-[#FFF7F1] py-16 md:py-36">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-12 gap-8 mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-7">
            <div className="flex items-center gap-3">
              <Star size={14} className="text-[#F0311B]" />
              <span className="font-condensed font-bold uppercase tracking-[0.25em] text-sm md:text-base text-[#FFF7F1]/80">
                {s.eyebrow}
              </span>
            </div>
            <h2 className="mt-4 font-display font-bold text-[13vw] sm:text-6xl md:text-7xl leading-[0.9]">
              {s.titleA} <span className="italic text-[#F0311B]">{s.titleAccent}</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:pt-6 text-[#FFF7F1]/75 text-base md:text-lg leading-relaxed">
            {s.subtitle}
          </div>
        </div>

        <ol className="border-t border-[#FFF7F1]/20">
          {s.items.map((it, i) => (
            <motion.li
              key={i}
              data-testid={`schedule-item-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="group flex flex-col md:grid md:grid-cols-12 md:gap-8 md:items-center py-6 md:py-8 border-b border-[#FFF7F1]/20 hover:bg-[#FFF7F1]/[0.03] transition-colors"
            >
              <div className="hidden md:block md:col-span-1 font-condensed text-xs md:text-sm text-[#FFF7F1]/60 tabular-nums">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="md:hidden flex items-center gap-3 mb-2">
                <span className="font-condensed text-[10px] text-[#FFF7F1]/50 tabular-nums tracking-[0.2em]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="flex-1 h-px bg-[#FFF7F1]/15" />
                <span className="font-condensed uppercase text-[9px] tracking-[0.22em] text-[#FFF7F1]/55">{it.note}</span>
              </div>
              <div className="md:col-span-3 font-display font-bold text-4xl md:text-5xl tabular-nums text-[#F0311B] leading-none">
                {it.time}
              </div>
              <div className="md:col-span-5 font-display font-semibold text-2xl md:text-4xl mt-1 md:mt-0">
                {it.event}
              </div>
              <div className="hidden md:block md:col-span-3 font-condensed uppercase text-[11px] tracking-[0.2em] text-[#FFF7F1]/60 text-right">
                {it.note}
              </div>
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  );
};
